import * as React from 'react';
import { PromptConfirmationModal } from 'ui';
import { CodetableItemProps } from 'app/area/codetable/list/list-items/types';
import { getConfirmPopupDescription } from 'app/area/codetable/list/shared/get-confirm-popup-description';

export const MeatballConfirmationWrapper = (props: CodetableItemProps) => {

  const { codetableId, codeItem, codeAccessConfiguration, isHierarchyMode, translation,
    deleteCodeItem, updateConfirmPrompt } = props;

  const confirmDescription = getConfirmPopupDescription(codeItem.description, codeItem.childrenCount, translation);

  const handleDeleteCodeItem = () => {
    deleteCodeItem({
      codetableId,
      codeId: codeItem.id,
      successMessage: translation.code_item_successfully_deleted,
      violationErrorMessage: translation.merge_code_violation_error
    });
  };

  const showConfirmPrompt = () =>
    updateConfirmPrompt({
      show: true,
      codetableId,
      codeId: codeItem?.id,
      description: confirmDescription,
      childrenCount: codeItem?.childrenCount
    });

  const isDnd = codeAccessConfiguration.canCreate && isHierarchyMode;

  return !isDnd
    ? <PromptConfirmationModal
      title={translation.delete_code_item_title}
      description={confirmDescription}
      continueText={translation.delete}
      cancelText={translation.cancel}
      onContinue={handleDeleteCodeItem}>
      <button
        type="button"
        className="dropdown-item">
        {translation?.delete}
      </button>
    </PromptConfirmationModal>
    : <button
      type="button"
      className="dropdown-item"
      onClick={showConfirmPrompt}>
      {translation?.delete}
    </button>;
};
